export default "__VITE_ASSET__BmI17Zel__"